import { useEffect, useLayoutEffect } from 'react';

export const useBrowserEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;
